import { DEFAULT_QUERY_SETTING } from "@/constants/variables";
import { getTags } from "@/features/create/services/tags.services";
import { ITagData } from "@/interfaces/IAgentData";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";

const useTags = () => {
  const [allTags, setAllTags] = useState<ITagData[]>([]);

  // Query --------------------------------------------------
  const { data: tags, isLoading: isTagsLoading } = useQuery({
    queryFn: () => getTags(),
    queryKey: ["dataTags"],
    ...DEFAULT_QUERY_SETTING,
  });
  // --------------------------------------------------------

  // USE EFFECT --------------------------------------------------
  useEffect(() => {
    if (tags && tags.data) {
      const sortedTags = tags.data.sort((a: ITagData, b: ITagData) =>
        a.name.localeCompare(b.name),
      );

      const filteredTags = sortedTags.filter(
        (tag: ITagData) => !tag.name.toLocaleLowerCase().startsWith("other"),
      );

      const otherTag = sortedTags.find((tag: ITagData) =>
        tag.name.toLocaleLowerCase().startsWith("other"),
      );
      if (otherTag) {
        filteredTags.push(otherTag);
      }

      setAllTags(filteredTags);
    }
  }, [tags]);

  return {
    allTags,
    isTagsLoading,
  };
};

export default useTags;
